import {
  Warning,
  ChartBar,
  Ticket,
  GraduationCap,
  SquaresFour,
  Lightbulb,
  Bell,
  Handshake,
  Calendar,
  Gear,
  ClipboardText,
  Buildings,
  Path,
  Folder,
  Users,
  Headset,
  Tag,
  LockKey,
  FilePdf,
  ChatCircleDots,
  Faders,
  BookOpen,
  Sparkle,
  CalendarCheck,
  CalendarDots,
  MapPin,
  Question,
  FileText,
  ClockCountdown,
  Robot,
  type Icon,
} from '@phosphor-icons/react';

export const MODULE_ICONS: Record<string, Icon> = {
  incidencias: Warning,
  encuestas: ChartBar,
  inscripciones: Ticket,
  cursos: GraduationCap,
  actividades: Calendar,
  home: SquaresFour,
  propuestas: Lightbulb,
  avisos: Bell,
  asociaciones: Handshake,
  agenda: Calendar,
  configuracion: Gear,
  formBuilder: ClipboardText,
  espacios: MapPin,
  instalaciones: Buildings,
  reservas: CalendarCheck,
  calendario: CalendarDots,
  procesos: Path,
  programas: FilePdf,
  areas: Folder,
  usuarios: Users,
  clientes: Buildings,
  tecnicos: Headset,
  categorias: Tag,
  roles: LockKey,
  informes: ChartBar,
  sla: ClockCountdown,
  asistentePortal: Robot,
  chatbot: ChatCircleDots,
  faq: Question,
  documentos: FileText,
  parametros: Faders,
  auditlog: ClipboardText,
  asistente: Sparkle,
  guia: BookOpen,
};

export function getModuleIcon(moduleId: string): Icon {
  return MODULE_ICONS[moduleId] ?? Gear;
}
